import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import PublicImage from "@/models/PublicImage/PublicImage";
import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";

export default class Information extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/information';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetInformations';

    static model_name = 'Information';

    static fields() {
        return {
            id: this.number(null).nullable(),
            media_library_item_id: this.number(null).nullable(),
            display_type: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            title_nl: this.attr(null),
            title_en: this.attr(null),
            information_nl: this.attr(null),
            information_en: this.attr(null),
            is_full_height: this.boolean(null),
            public_image_id: this.number(null).nullable(),
            public_image_x_position: this.number(null).nullable(),
            public_image_y_position: this.number(null).nullable(),
            image_opacity: this.number(null).nullable(),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
            mediaLibraryItem: this.belongsTo(MediaLibraryItem, 'media_library_item_id'),
        }
    }

    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }


}
